// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// (window as any).Pusher = Pusher;

// const echo = new Echo({
//   broadcaster: 'reverb',
//   key: '5xm7g111bp458iqib2i7',

//   wsHost: '127.0.0.1',
//   wsPort: 8080,

//   forceTLS: false,
//   disableStats: true,

//   enabledTransports: ['ws'],
// });

// export { echo };
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// (window as any).Pusher = Pusher;

// // استبدل بـ 'backendproduction.blueboxpet.com' في ملف الـ environment الخاص بالـ production
// const isProduction = true; // يمكنك ربطها بـ environment.production في Angular

// const echo = new Echo({
//   broadcaster: 'reverb',
//   key: '5xm7g111bp458iqib2i7', // تأكد أن هذا الـ Key يطابق REVERB_APP_KEY في الـ .env

//   wsHost: isProduction ? 'backendproduction.blueboxpet.com' : '127.0.0.1',

//   // في الـ Production نستخدم بورت 443 للـ SSL، وفي التيست نستخدم 8080
//   wsPort: isProduction ? 8080 : 8080,
//   wssPort: isProduction ? 8080 : 8080,

//   // يجب أن يكون true في الـ Production لتفعيل التشفير HTTPS/WSS
//   forceTLS: isProduction,

//   disableStats: true,
//   enabledTransports: ['ws', 'wss'],
// });

// export { echo };
// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// (window as any).Pusher = Pusher;

// const echo = new Echo({
//   broadcaster: 'reverb',
//   key: '5xm7g111bp458iqib2i7',

//   // نستخدم الدومين الرئيسي أو الفرعي
//   wsHost: 'reverb.blueboxpet.com',

//   // محاولة الاتصال المباشر بالبورت الذي يعمل عليه Reverb
//   // ملاحظة: أغلب الاستضافات المشتركة تغلق هذا البورت خارجياً
//   wsPort: 8080,
//   wssPort: 8080,

//   // بما أننا لا نستطيع عمل Proxy للـ SSL على بورت 8080 في الاستضافة المشتركة
//   // فغالباً ستحتاج لتعطيل TLS لتجربة الاتصال أولاً
//   forceTLS: false,

//   enabledTransports: ['ws', 'wss'],
// });

// export { echo };
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

(window as any).Pusher = Pusher;

const echo = new Echo({
  broadcaster: 'pusher',
  key: '585ccb99d5b81591a87a', // الـ Key بتاعك من الصورة
  cluster: 'eu',               // الكلاستر بتاعك
  forceTLS: true               // مهم جداً عشان يشتغل على بورت 443
});

export { echo };
